export default "__VITE_ASSET__MfPVLfYk__"